import * as React from "react";
import { createSvgIcon } from "../utils";

export const Add = createSvgIcon(
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.947 4c.402 0 .727.326.727.727v6.546h6.546a.727.727 0 0 1 0 1.454h-6.546v6.546a.727.727 0 1 1-1.454 0v-6.546H5.674a.727.727 0 1 1 0-1.454h6.546V4.727c0-.401.325-.727.727-.727Z"
    />,
    "Add",
);

export default Add;
